import * as pdfjs from "pdfjs-dist";
pdfjs.GlobalWorkerOptions.workerSrc =
  require("!!file-loader?outputPath=assets/js&name=[name]-[hash].js!pdfjs-dist/build/pdf.worker.min.js").default;  

export async function generatePDFThumbnail(file) {
    let src = file.url === undefined ? URL.createObjectURL(file) : file.url;
    const pdfUrl = src; // Replace with the URL or path to your PDF file
    const pdfDocument = await pdfjs.getDocument(pdfUrl).promise;
    return renderPage(pdfDocument);
  }

  function calculateViewportHeight(viewportWidth, pageWidth, pageHeight) {
    // Calculate the aspect ratio of the PDF page
    const aspectRatio = pageWidth / pageHeight;

    // Calculate the height based on the desired width (1200px)
    const viewportHeight = viewportWidth / aspectRatio;

    return viewportHeight;
  }

  async function renderPage(pdfInstance) {
    const page = await pdfInstance.getPage(1);
    const MAX_LENGTH_PDF = 300;
    const viewportWidth = window.innerWidth < MAX_LENGTH_PDF ? window.innerWidth : MAX_LENGTH_PDF;
    const scale = viewportWidth / page.getViewport({ scale: 1 }).width;
    const viewportHeight = calculateViewportHeight(
      viewportWidth,
      page.getViewport({ scale }).width,
      page.getViewport({ scale }).height
    );
    const viewport = page.getViewport({ scale, height: viewportHeight });

    // Create a canvas element for the page
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({ canvasContext: context, viewport }).promise;
    return await new Promise(resolve => canvas.toBlob(resolve))
  };